
      // Mobile menu toggle only
      const menuToggle = document.getElementById('menu-toggle');
      const navMenu = document.getElementById('nav-menu');
      
      // Add login redirect function
      window.redirectToLogin = function() {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const loginUrl = isLocalhost ? 'http://localhost:5173/logga-in' : 'https://dedox.se/app/logga-in';
        window.location.href = loginUrl;
      };
      
      if (menuToggle && navMenu) {
        menuToggle.addEventListener('click', () => {
          navMenu.classList.toggle('active');
        });
      }
    